import { cn } from '@/lib/cn';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse bg-surface-2 border border-transparent', className)}
      aria-hidden
    />
  );
}
